/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkintask_TitleInputs */

const en_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily Check-in`)
};

const ar_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التسجيل اليومي`)
};

const de_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täglicher Check-in`)
};

const es_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro diario`)
};

const fr_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement quotidien`)
};

const it_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in giornaliero`)
};

const ja_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デイリーチェックイン`)
};

const ko_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출석체크`)
};

const pt_br_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in diário`)
};

const ru_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежедневный вход`)
};

const th_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเช็คอินประจำวัน`)
};

const tr_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günlük Check-in`)
};

const zh_cn_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日签到`)
};

const zh_tw_checkintask_title = /** @type {(inputs: Checkintask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日打卡`)
};

/**
* | output |
* | --- |
* | "Daily Check-in" |
*
* @param {Checkintask_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const checkintask_title = /** @type {((inputs?: Checkintask_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkintask_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkintask_title(inputs)
	if (locale === "ar") return ar_checkintask_title(inputs)
	if (locale === "de") return de_checkintask_title(inputs)
	if (locale === "es") return es_checkintask_title(inputs)
	if (locale === "fr") return fr_checkintask_title(inputs)
	if (locale === "it") return it_checkintask_title(inputs)
	if (locale === "ja") return ja_checkintask_title(inputs)
	if (locale === "ko") return ko_checkintask_title(inputs)
	if (locale === "pt_br") return pt_br_checkintask_title(inputs)
	if (locale === "ru") return ru_checkintask_title(inputs)
	if (locale === "th") return th_checkintask_title(inputs)
	if (locale === "tr") return tr_checkintask_title(inputs)
	if (locale === "zh_cn") return zh_cn_checkintask_title(inputs)
	return zh_tw_checkintask_title(inputs)
});